<script>
  import { station } from "./stores/station.js";
  import { getRandomColor } from "./utils.js";
  import { onMount, onDestroy } from "svelte";

  let textColor;
  let intervalId;

  onMount(() => {
    intervalId = setInterval(() => {
      textColor = getRandomColor(true);
    }, 1500);
  });

  onDestroy(() => {
    clearInterval(intervalId);
  });
</script>

{#if $station}
  <!-- content here -->
  <div class="bg">
    <div class="container" style="color: {textColor}">
      {#if $station.nowPlaying}
        <div class="nowPlaying">Now Playing:</div>
        <div class="title">{$station.nowPlaying.title}</div>
      {:else}
        <div class="title">Commencing party</div>
      {/if}

      {#if $station.state != "playing" && $station.NowPlaying}
        <div class="state">{$station.state}</div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .bg {
    min-height: 168px;
    width: 100%;
    background: #20202061;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    padding: 32px;
  }

  .container {
    width: 100%;
    max-width: 480px;
    padding: 8px;
    box-sizing: border-box;
    transition: color 750ms linear;
  }

  .title {
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
    font-size: 24px;
  }

    @media (max-width: 576px) {
    .bg{
      margin: 0;
    }
  }
</style>
